import React from "react";
import {
  CircularProgress,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { FieldColumn, FieldRow, Section } from "../styles";
import { AgentFormState } from "../../../types/agentTypes";
import { SelectMotivationType } from "../types";
import Provider from "../../../enum/Provider.enum";
import ManagerAutocompleteNew from "../../ManagerAutocompleteNew";

type MotivationSectionProps = {
  formData: AgentFormState;
  provider: Provider;
  motivations: SelectMotivationType[];
  motivationsLoading: boolean;
  setFormData: React.Dispatch<React.SetStateAction<AgentFormState>>;
};

const MotivationSection = ({
  formData,
  provider: _provider,
  motivations,
  motivationsLoading,
  setFormData,
}: MotivationSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <FieldRow>
        <FieldColumn>
          <ManagerAutocompleteNew
            value={formData?.manager_id ?? null}
            label={t("createAgent.motivation.manager")}
            onSelect={(val: any) => {
              setFormData((prev) => ({
                ...prev,
                manager_id: val ? val.value : "",
              }));
            }}
          />
        </FieldColumn>

        <FieldColumn>
          <FormControl fullWidth size="small">
            <InputLabel id="type_motivation-label">
              {t("createAgent.motivation.type")}
            </InputLabel>

            <Select
              name="type_motivation"
              label={t("createAgent.motivation.type")}
              labelId="type_motivation-label"
              value={
                !motivationsLoading ? (formData?.type_motivation ?? "") : ""
              }
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  type_motivation: e.target.value,
                }));
              }}
              required
              fullWidth
              input={
                <OutlinedInput
                  size="small"
                  label={t("createAgent.motivation.type")}
                  endAdornment={
                    motivationsLoading && (
                      <InputAdornment position="end" sx={{ mr: 2 }}>
                        <CircularProgress size={20} />
                      </InputAdornment>
                    )
                  }
                />
              }
            >
              {motivations?.map((m) => (
                <MenuItem key={m.id} value={m.id} disabled={m.is_hidden}>
                  {m.description ||
                    `${t("createAgent.motivation.noName")} ${m.id}`}{" "}
                  {m.is_hidden ? t("createAgent.motivation.hidden") : ""}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </FieldColumn>

        <FieldColumn>
          <FormControl fullWidth size="small">
            <InputLabel id="lang_dog-label">
              {t("createAgent.motivation.contractLanguage")}
            </InputLabel>

            <Select
              name="lang_dog"
              label={t("createAgent.motivation.contractLanguage")}
              labelId="lang_dog-label"
              value={formData.lang_dog ?? ""}
              onChange={(e) => {
                setFormData((prev) => ({
                  ...prev,
                  lang_dog: e.target.value,
                }));
              }}
              required
              fullWidth
            >
              <MenuItem value="ENG">ENG</MenuItem>
              <MenuItem value="RUS">RUS</MenuItem>
            </Select>
          </FormControl>
        </FieldColumn>
      </FieldRow>
    </Section>
  );
};

export default MotivationSection;
